import { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import api from "../../services/api";

export default function ManageDepartments() {

  const [departments, setDepartments] = useState([]);
  const [name, setName] = useState("");

  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  const loadDepartments = () => {
    api.get("/admin/departments")
      .then(res => setDepartments(res.data))
      .catch(err => console.log(err));
  };

  useEffect(() => {
    loadDepartments();
  }, []);


  /* ADD */

  const addDepartment = async () => {

    if (!name) return;

    await api.post("/admin/departments", { name });

    setName("");
    loadDepartments();

  };


  /* DELETE */

  const deleteDepartment = async (id) => {

    if (!window.confirm("Delete this department?")) return;

    await api.delete(`/admin/departments/${id}`);

    loadDepartments();

  };


  /* EDIT */

  const startEdit = (dept) => {

    setEditId(dept.id);
    setEditName(dept.name);

  };


  const updateDepartment = async () => {

    await api.put(`/admin/departments/${editId}`, {
      name: editName
    });

    setEditId(null);
    setEditName("");

    loadDepartments();

  };


  return (

    <div className="min-h-screen bg-gray-50">

      <Navbar />

      <div className="max-w-4xl mx-auto p-10">

        <h2 className="text-2xl font-bold mb-6">
          Manage Departments
        </h2>


        {/* Add Department */}

        <div className="flex gap-4 mb-8">

          <input
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Department name"
            className="border p-2 flex-1 rounded"
          />

          <button
            onClick={addDepartment}
            className="bg-green-600 text-white px-4 py-2 rounded"
          >
            Add
          </button>

        </div>


        {/* Departments List */}

        <div className="bg-white shadow rounded">

          {departments.map(d => (

            <div
              key={d.id}
              className="flex justify-between items-center border-b p-4"
            >

              {editId === d.id ? (

                <input
                  value={editName}
                  onChange={e => setEditName(e.target.value)}
                  className="border p-2 flex-1 mr-4"
                />

              ) : (

                <span className="font-medium">
                  {d.name}
                </span>

              )}


              <div className="flex gap-2">

                {editId === d.id ? (

                  <>
                    <button
                      onClick={updateDepartment}
                      className="bg-blue-600 text-white px-3 py-1 rounded"
                    >
                      Save
                    </button>

                    <button
                      onClick={() => setEditId(null)}
                      className="bg-gray-400 text-white px-3 py-1 rounded"
                    >
                      Cancel
                    </button>
                  </>

                ) : (

                  <>
                    <button
                      onClick={() => startEdit(d)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded"
                    >
                      Edit
                    </button>

                    <button
                      onClick={() => deleteDepartment(d.id)}
                      className="bg-red-600 text-white px-3 py-1 rounded"
                    >
                      Delete
                    </button>
                  </>

                )}

              </div>

            </div>

          ))}

        </div>

      </div>

    </div>

  );

}